<template>
<div>
  <v-card>
    <v-card-title class="title">
      {{ title }}
    </v-card-title>
    <v-progress-circular v-if="chartLoading" :size="70" :rotate="30" :width="5" class="loading-circle" indeterminate></v-progress-circular>
    <div v-else>
      <v-layout>
        <v-flex xs2 class="margin-left">
          <v-select item-text="name" item-value="value" :items="itemsTrueFalse" v-model="showDataLabels" label="Pkazuj etykiety"></v-select>
        </v-flex>
        <v-flex xs2 class="margin-left">
          <v-select item-text="name" item-value="value" :items="itemsTrueFalse" v-model="xAsDataTime" label="Oś czasu"></v-select>
        </v-flex>
        <v-flex xs2 class="margin-left">
          <v-select :items="groupDateMethods" v-model="group.method" :label="`${$t('Grupuj po')}`" item-text="name" item-value="id" required> </v-select>
        </v-flex>
        <v-flex xs2>
          <v-btn @click="load()" color="primary" slot="activator">
            {{ $t('stats.load') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <apex-chart type="line" height="400" :options="options" :series="series"></apex-chart>
    </div>
  </v-card>
</div>
</template>

<script>
import apexcharts from 'vue-apexcharts'
import http from '@/plugins/http'

export default {
  components: {
    'apex-chart': apexcharts
  },
  props: ['dateFrom', 'dateTo', 'categories', 'series', 'title', 'id'],
  data() {
    return {
      groupDateMethods: [{
        'name': 'Roku',
        'id': 'YEAR'
      }, {
        'name': 'Miesiącu',
        'id': 'MONTH'
      }, {
        'name': 'Kwartale',
        'id': 'QUARTER'
      }, {
        'name': 'Dniu',
        'id': 'DAY'
      }],
      schema: {},
      group: {},
      fields: [],
      chartLoading: false,
      chartData: [],
      showDataLabels: true,
      itemsTrueFalse: [{
        name: "Tak",
        value: true
      }, {
        name: "Nie",
        value: false
      }],
      xAsDataTime: true
    }
  },
  computed: {
    options() {
      return {
        chart: {
          id: `2Form-${this.title}`,
          toolbar: {
            autoSelected: 'zoom'
          },
          zoom: {
            type: 'x',
            enabled: true
            // autoScaleYaxis: true
          }
        },
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
        xaxis: {
          type: this.xAsDataTime ? "datetime" : "category",
          categories: this.categories ? this.categories : [],
          labels: {
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM",
              day: 'dd.MM',
              hour: 'HH:mm',
            },
          }
        },
        dataLabels: {
          enabled: this.showDataLabels,
          position: "left",
          textAnchor: "middle",
          offsetY: -20,
          dropShadow: {
            enabled: true,
            left: 2,
            top: 2,
            opacity: 0.5
          },
          style: {
            colors: ['#800040', '#1a0000', '#804000', '#331a00']
          },
        },
        // stroke: {
        //   curve: 'smooth'
        // },
      }
    }
  },
  methods: {
    load() {
      let params = '?'
      if (this.dateFrom != "")
        params += 'from=' + this.dateFrom + '&'
      if (this.dateTo != "")
        params += 'to=' + this.dateTo
      if (this.group.method != "")
        params += '&group_metod=' + this.group.method

      http.get('statistics/single-stats/' + this.id + params)
        .then(({
          data
        }) => {
          this.stats = data
          this.series = data.series
          this.categories = data.categories
          this.chartLoading = false
        }).catch(() => {
          this.chartLoading = false
        })
    }
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.margin-left {
  margin-left: 2rem;
}

.apexcharts-canvas.dark {
  background: transparent !important;
}
</style>
